import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import phConfused from "../../../assets/images/blurred2/imoji/Confused.png";
import phHead_with_tap from "../../../assets/images/blurred2/imoji/Head_with_tap.png";
import phStruggling from "../../../assets/images/blurred2/imoji/Struggling.png";
import phConfort from "../../../assets/images/blurred2/imoji/confort.png";
import ImageButton from "../../../components/ImageButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

const buttonText = [
  t("financial_situation.struggling"),
  t("financial_situation.stability"),
  t("financial_situation.unsure"),
  t("financial_situation.comfortable"),
];

const data = [
  {
    image: addS3Url("/imoji/Struggling.png"),
    placeHolderImage: phStruggling,
  },
  {
    image: addS3Url("/imoji/Head_with_tap.png"),
    placeHolderImage: phHead_with_tap,
  },
  {
    image: addS3Url("/imoji/Confused.png"),
    placeHolderImage: phConfused,
  },
  {
    image: addS3Url("/imoji/confort.png"),
    placeHolderImage: phConfort,
  },
];

const FSituation = () => {
  const params = useParams();
  return (
    <MobileViewLayout>
      <div className="d-flex flex-column justify-content-center align-items-center px-3">
        <h3 className="text-black fw-bold text-center  m-0 fs30 age-selection-heading">
          <Trans i18nKey={"financial_situation.question"} />
        </h3>
        <div className="d-flex flex-column justify-content-around align-items-center w-100 pb-2">
          <div
            className="d-flex justify-content-around w-100"
            style={{ paddingBottom: "20px" }}
          >
            {data.slice(0, 2).map((item, index) => (
              <ImageButton
                key={index}
                highlightButton={"button-highlight fsituation-button"}
                backgroundStyle={{
                  backgroundColor: "#F2F2F2",
                }}
                navigateTo={{
                  pathname: `/${params.gender}/incomeslab`,
                }}
                imageStyle={{
                  width: "35%",
                  minHeight: "50px",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
                buttonClasses={
                  "w-100 pb-4 fsituation-button-text semibold fsituation-text"
                }
                {...item}
                buttonText={buttonText[index]}
              />
            ))}
          </div>
          <div className="d-flex justify-content-around w-100">
            {data.slice(2, 4).map((item, index) => (
              <ImageButton
                key={index}
                highlightButton={"button-highlight fsituation-button"}
                backgroundStyle={{
                  backgroundColor: "#F2F2F2",
                }}
                navigateTo={{
                  pathname: `/${params.gender}/incomeslab`,
                }}
                imageStyle={{
                  width: "35%",
                  paddingTop: "20px",
                  minHeight: "50px",
                  paddingBottom: "20px",
                }}
                buttonClasses={
                  "w-100 pb-4 fsituation-button-text semibold fsituation-text"
                }
                {...item}
                buttonText={buttonText[2 + index]}
              />
            ))}
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default FSituation;
